import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
  BackArrowIcon, DeleteIcon, ReconfigIcon, StartIcon, StopIcon,
  WarningIcon, ScaleIcon
} from "../../../components/Svg";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Features, Urls } from "../../../constants";
import { mergeUrl } from "../../../utils/url";
import { AiTabs, AiTab } from '../../../components/AiTabs';
import Ai, { selectAllVMs, selectGpuCluster } from '../../../store/models/Ai';
import { getLinkByDeployment, getStatus, getHardwareDetail, getPodId, getStatusSum, formatDate, checkActivePod, checkDeploymentsReady, getClusterStatusSum } from '../../../utils';
import classNames from 'classnames';
import Loader from '../../../components/Loader';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { Button } from '../../../components/Button';
import { authHeaders } from "../../../utils/fetch";
import { Hosts, ModalTypes } from "../../../constants";
import AiStorage, { getFormateStorageSize, selectAllStorages } from '../../../store/models/AiStorage';
import { selectIsFeatureEnabled } from '../../../store/models/Organization';
import UIState from '../../../store/UIState';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import User from '../../../store/models/User';


function GpuClusterDetailPage() {
  const dispatch = useDispatch();
  const { projectId, shard, suffix, id } = useParams();
  const history = useHistory();
  const logRef = useRef("")
  const [logs, setLogs] = useState("")
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [deployments, setDeployments] = useState();
  const cluster = useSelector(state => selectGpuCluster(state, projectId, suffix || id));
  const volumes = useSelector(state => selectAllStorages(state));

  const link = cluster ? getLinkByDeployment(cluster) : '';
  const httpPort = _.get(cluster, 'ContainerPort');
  const vms = useSelector(state => selectAllVMs(state));
  const isStorageEnabled = useSelector(state => selectIsFeatureEnabled(state, Features.STORAGE));
  const isStopped = !!id;
  let userId = isStopped ? _.get(cluster, 'UserID') : _.get(cluster, 'UserID');
  let hasVolume = isStopped ? cluster?.sharedVolumes?.length > 0 : cluster?.SharedVolumes?.length > 0;
  let curVolumes = isStopped ? _.get(cluster, 'sharedVolumes') : _.get(cluster, 'SharedVolumes')
  if (!userId || userId.startsWith('prj')) userId = null;
  else userId = 'usr_' + userId;
  const [userName, setUserName] = useState();
  let timeoutId;

  useEffect(() => {
    let loop;
    let retry;

    const streamLogs = async () => {
      let response;
      let url = Hosts.EDGE_CLOUD_CONTROLLER_API + `/cluster/${shard}/${suffix}/logs?follow=true&project_id=${projectId}`
      try {
        response = await fetch(url, { headers: authHeaders() });
        if (response.status !== 200) {
          retry = setTimeout(() => streamLogs(), 10 * 1000);
          return;
        }
        const reader = response.body.getReader();

        const read = async () => {
          const { done, value } = await reader.read();
          logRef.current = logRef.current.concat(new TextDecoder().decode(value))
          if (done || isStopped) {
            setLogs(logRef.current)
            clearTimeout(loop)
            streamLogs()
            return;
          }
          setLogs(logRef.current)
          loop = setTimeout(() => {
            read().then().catch(err => {
              logRef.current = ""
              setLogs(logRef.current)
              retry = setTimeout(() => streamLogs(), 10);
            })
          }, 10)
        }

        read().then().catch(err => {
          console.log(err)
          logRef.current = ""
          setLogs(logRef.current)
          retry = setTimeout(() => streamLogs(), 10);
        })

      } catch (err) {
        if (typeof err === 'string') {
          console.log("URL is unreachable: ", url, err);
          return;
        }
      }
    }

    (async () => {
      let force = false;
      // let force = (getStatus(_.get(cluster, 'PodPhase')) === 'stopped' || getStatus(_.get(cluster, 'PodPhase')) === 'Running') ? false : true;
      // console.log('force:', force)
      // console.log("(getStatus(_.get(cluster, 'PodPhase')) === 'stopped' || getStatus(_.get(cluster, 'PodPhase')) === 'Running'):", (getStatus(_.get(cluster, 'PodPhase')) === 'stopped' || getStatus(_.get(cluster, 'PodPhase')) === 'Running'))
      // console.log('getStatus(_.get(cluster, "PodPhase")):', getStatus(_.get(cluster, "PodPhase")))
      // console.log('cluster.PodPhase:', _.get(cluster, 'PodPhase'))
      await fetchDataLoop(force);
      // todo: get cluster logs
      // if (!isStopped) streamLogs();
    })();

    return () => {
      clearTimeout(loop);
      clearTimeout(retry);
    };

  }, [projectId, shard, suffix, isStopped]);

  useEffect(() => {
    async function fetchUser() {
      if (!userId || isStopped) return;
      let userRes = await dispatch(User.actions.fetchUser(userId));
      setUserName(`${_.get(userRes, 'first_name') || ''} ${_.get(userRes, 'last_name') || ''}`)
    }
    fetchUser();
  }, [userId, isStopped])

  const fetchData = async (force) => {
    if (!force) setLoading(true);
    if (error) setError();
    try {
      if (id) {
        await dispatch(Ai.actions.fetchGpuClusterBaseDetail(projectId, id));
      } else {
        await dispatch(Ai.actions.fetchGpuClusterDetail(projectId, suffix));
        let res = await dispatch(Ai.actions.fetchGpuClusterDeployments(projectId, suffix));
        console.log('res:', res)
        setDeployments(res);
        let newEvents = [];
        // ToDo: implement getClusterVolumes and fetchClusterEvents
        for (let deployment of res) {
          console.log('deployment:', deployment);
          await dispatch(AiStorage.actions.getDeploymentVolumes(projectId, _.get(deployment, 'Shard'), _.get(deployment, 'Suffix')));
          const eventsRres = await dispatch(Ai.actions.fetchDeploymentEvents(projectId, _.get(deployment, 'Shard'), _.get(deployment, 'Suffix')));
          newEvents = [...newEvents, ...eventsRres];
        }
        setEvents(newEvents)
      }
      if (Object.keys(volumes).length === 0) {
        await dispatch(AiStorage.actions.fetchStorages(projectId));
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  async function fetchDataLoop(force) {
    try {
      await fetchData(force);
      if (force || !checkDeploymentsReady([cluster])) {
        timeoutId = setTimeout(() => fetchDataLoop(force), 1000 * 5)
      }
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  }

  useEffect(() => {
    return () => { clearTimeout(timeoutId) };
  }, [])


  const [selectedSubTab, setSelectedSubTab] = useState('details');

  const handleDelete = () => {
    const onConfirm = async () => {
      try {
        setLoading(true);
        if (cluster.Suffix) {
          await dispatch(Ai.actions.deleteGpuCluster(projectId, cluster.Suffix));
        } else {
          await dispatch(Ai.actions.deleteGpuClusterBase(projectId, cluster.id));
        }
        history.push(mergeUrl(Urls.AI_GPU_CLUSTER, { projectId }));
        toast.success(`The cluster has been deleted.`)
      } catch (e) {
        toast.error(`Failed to delete the cluster. Error: ${e.message}`)
        setLoading(false);
      }
    }
    let title = isStopped ? cluster.name : cluster.Name;
    dispatch(UIState.actions.showModal(ModalTypes.DELETE, { title, onConfirm }));
  }

  const handleReconfigure = () => {
    let url = mergeUrl(Urls.AI_GPU_NODE_UPDATE, { projectId, id: cluster.id })
    history.push(url + '?t=detail');
  }

  const handleStart = () => {
    const onConfirm = async () => {
      try {
        setLoading(true);
        let res = await dispatch(Ai.actions.startDeployment(projectId, cluster.id));
        setTimeout(() => {
          history.push(mergeUrl(Urls.AI_GPU_NODE_DETAIL, { projectId, suffix: _.get(res, 'Suffix'), shard: _.get(res, 'Shard') }));
        }, 2000)
        toast.success(`The cluster has been started.`)
      } catch (e) {
        toast.error(`Failed to start the cluster. Error: ${e.message}`);
        setLoading(false);
      }
    }
    dispatch(UIState.actions.showModal(ModalTypes.CONFIRM, {
      title: "Start cluster",
      message: "Are you sure you want to start the cluster?",
      onConfirm: onConfirm,
      confirmLabel: "Yes",
      cancelLabel: "No",
      size: 's'
    }));
  }

  const handleStop = () => {
    const onConfirm = async () => {
      try {
        setLoading(true);
        let res = await dispatch(Ai.actions.stopDeployment(projectId, cluster.Shard, cluster.Suffix));
        history.push(mergeUrl(Urls.AI_GPU_NODE_DETAIL_BASE, { projectId, id: _.get(res, 'ID') }));
        toast.success(`The cluster has been stopped.`)
      } catch (e) {
        toast.error(`Failed to stop the cluster. Error: ${e.message}`);
        setLoading(false);
      }
    }
    dispatch(UIState.actions.showModal(ModalTypes.CONFIRM, {
      title: <div style={{ display: 'flex' }}>
        <div style={{ marginRight: 10 }}><WarningIcon /></div>
        Stop cluster
      </div>,
      message: <div style={{ padding: 10 }}>
        Data stored in ephemeral storage will be lost when a GPU node is stopped. To ensure data preservation, we recommend attaching a persistent volume to your GPU node during its creation. Persistent volumes safely retain data even when the node is stopped.
      </div>,
      onConfirm: onConfirm,
      confirmLabel: "Yes",
      cancelLabel: "No",
      size: 's'
    }));
  }

  const handleScale = () => {
    dispatch(UIState.actions.showModal(ModalTypes.SCALE_GPU_CLUSTER, { suffix, fetchData }));
  }

  return (<div className={'AiServicePage AiServicePage--with-back-button'}>
    <Link to={mergeUrl(Urls.AI_GPU_CLUSTER, { projectId })}>
      <div className={'AiServicePage__back-button gpu-node'}>
        <BackArrowIcon />
        <div className={'AiServicePage__back-button--label'}>
          GPU Cluster
        </div>
      </div>
    </Link>
    {!loading && cluster && <div className={'AiServicePage__header detail'}>
      <div className={'AiServicePage__header--title'}>{cluster.Name || cluster.name || cluster.id}</div>
      {httpPort > 0 && <div className={classNames(`AiServicePage__header--button detail`, { 'disabled': !checkActivePod(cluster) })}>
        {checkActivePod(cluster) ? <a href={link} target='_blank' >
          HTTP Endpoint
        </a> : <>
          <Loader size='small' color='grey' />
          HTTP Endpoint
        </>}
      </div>}
    </div>}
    {!loading && cluster && <div className={'AiServicePage__action-bar'}>
      <div className={'AiServicePage__action-button stop'} onClick={handleScale}>
        <ScaleIcon />
        Scale
      </div>
      {/* {!isStopped && <div className={'AiServicePage__action-button stop'} onClick={handleStop}>
        <StopIcon />
        Stop
      </div>}
      {isStopped && <div className={'AiServicePage__action-button start'} onClick={handleStart}>
        <StartIcon />
        Start
      </div>} */}
      <div className={'AiServicePage__action-button delete'} onClick={handleDelete}>
        <DeleteIcon />
        Delete
      </div>
      {isStopped && <div className={'AiServicePage__action-button reconfig'} onClick={handleReconfigure}>
        <ReconfigIcon />
        Reconfig
      </div>}
    </div>
    }
    {!loading && cluster && <div className={'AiServicePage__content new-cluster'}>
      <AiTabs>
        <AiTab isSelected={(selectedSubTab === 'details')}
          onClick={() => {
            setSelectedSubTab('details')
          }}>
          Details
        </AiTab>
        {!isStopped && <AiTab isSelected={(selectedSubTab === 'nodes')}
          onClick={() => {
            setSelectedSubTab('nodes')
          }}>
          Nodes
        </AiTab>}
        {/* <AiTab isSelected={(selectedSubTab === 'stats')}
          onClick={() => {
            setSelectedSubTab('stats')
          }}>
          Stats
        </AiTab> */}
        {!isStopped && <AiTab isSelected={(selectedSubTab === 'logs')}
          onClick={() => {
            setSelectedSubTab('logs')
          }}>
          Logs
        </AiTab>}
        {!isStopped && <AiTab isSelected={(selectedSubTab === 'events')}
          onClick={() => {
            setSelectedSubTab('events')
          }}>
          Events
        </AiTab>}
      </AiTabs>
      {
        (selectedSubTab === 'details') && cluster &&
        <div className='AiServicePage__tab-content'>
          {deployments && <DeploymentsCard deployments={deployments} />}
          <div className='ModelDeploymentDetailPage__details'>
            <div className='ModelDeploymentDetailPage__details--row section'>
              <div className='ModelDeploymentDetailPage__details--section-title'>
                CLUSTER STATUS
              </div>
            </div>
            {isStopped && <>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Deployment ID
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {cluster.name}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Name
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {_.get(cluster, 'annotations.nickname')}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Status
                </div>
                <div className='ModelDeploymentDetailPage__details--value status'>
                  {getClusterStatusSum(cluster.Status)}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Created
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {formatDate(cluster.create_time)}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Region
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {cluster.selected_region || 'N/A'}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Price
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {`$0`}
                </div>
              </div>
            </>}
            {!isStopped && <>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Deployment Key
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {cluster.Suffix}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Deployment ID
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {cluster.Name}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Name
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {_.get(cluster, 'NodeAnnotations.nickname')}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Size
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {_.get(cluster, 'size')}
                </div>
              </div>
              {httpPort > 0 && <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  HTTP Endpoint
                </div>
                <div className={classNames('ModelDeploymentDetailPage__details--value green',
                  { disabled: !checkActivePod(cluster) })}>
                  {checkActivePod(cluster) ? <a href={link} target='_blank' >
                    {link}
                  </a> : link}
                </div>
              </div>}
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Status
                </div>
                <div className='ModelDeploymentDetailPage__details--value status'>
                  {getClusterStatusSum(cluster.Status)}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Created
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {formatDate(cluster.CreatedAt)}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Region
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {cluster.SelectedRegion}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Price
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {`$${(vms[cluster.NodeMachineType].price_hour) / 100} x ${_.get(cluster, 'size')} per hour`}
                </div>
              </div>
              <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Creator User ID
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {userId}
                </div>
              </div>
              {userName && <div className='ModelDeploymentDetailPage__details--row'>
                <div className='ModelDeploymentDetailPage__details--title'>
                  Creator User Name
                </div>
                <div className='ModelDeploymentDetailPage__details--value'>
                  {userName}
                </div>
              </div>}
            </>}
            <div className='ModelDeploymentDetailPage__details--row section'>
              <div className='ModelDeploymentDetailPage__details--section-title'>
                METADATA
              </div>
            </div>
            <div className='ModelDeploymentDetailPage__details--row'>
              <div className='ModelDeploymentDetailPage__details--title'>
                Image
              </div>
              <div className='ModelDeploymentDetailPage__details--value'>
                {isStopped ? cluster.container_image : cluster.NodeImageURL}
              </div>
            </div>
            <div className='ModelDeploymentDetailPage__details--row'>
              <div className='ModelDeploymentDetailPage__details--title'>
                Hardware
              </div>
              <div className='ModelDeploymentDetailPage__details--value'>
                {getHardwareDetail(vms, (isStopped ? cluster.vm_id : cluster.NodeMachineType))}
              </div>
            </div>

            {isStorageEnabled && <>
              <div className='ModelDeploymentDetailPage__details--row section'>
                <div className='ModelDeploymentDetailPage__details--section-title'>
                  STORAGE
                </div>
              </div>

              <div className='ModelDeploymentDetailPage__storage'>
                <div className='ModelDeploymentDetailPage__storage--header'>
                  <div className='ModelDeploymentDetailPage__storage--cell'>Name</div>
                  <div className='ModelDeploymentDetailPage__storage--cell'>ID</div>
                  <div className='ModelDeploymentDetailPage__storage--cell'>Mounted at</div>
                  <div className='ModelDeploymentDetailPage__storage--cell'>Volume size</div>
                  {/* <div className='ModelDeploymentDetailPage__storage--cell'>Cost</div> */}
                </div>
                {hasVolume ? (
                  curVolumes.map((storage, i) => {
                    const storageDetail = _.find(volumes, volume => volume.Suffix === storage.volumeId);
                    return (
                      <div key={i} className='ModelDeploymentDetailPage__storage--row'>
                        <div className='ModelDeploymentDetailPage__storage--cell'>{storageDetail?.DisplayName}</div>
                        <div className='ModelDeploymentDetailPage__storage--cell'>{storageDetail?.Name}</div>
                        <div className='ModelDeploymentDetailPage__storage--cell'>{storage.mountPath || '-'}</div>
                        <div className='ModelDeploymentDetailPage__storage--cell'>{getFormateStorageSize(storageDetail)}</div>
                        {/* <div className='ModelDeploymentDetailPage__storage--cell'>${storageDetail?.Cost || '-'} per hour</div> */}
                      </div>
                    )
                  })
                ) : (
                  <div className='ModelDeploymentDetailPage__storage--row empty'>
                    <div className='ModelDeploymentDetailPage__storage--cell' colSpan="5">No persistent volumes attached</div>
                  </div>
                )}
              </div>
            </>}
          </div>
        </div>
      }
      {
        (selectedSubTab === 'nodes') && cluster &&
        <div className='AiServicePage__tab-content'>
          {deployments.map((deployment, di) => {
            console.log('deployment:', deployment)
            return <div key={di}>
              <div className='ModelDeploymentDetailPage__nodes--label'>
                node{di + 1} ({_.get(deployment, 'Suffix')})
              </div>
              {deployment.PodPhase &&
                deployment.PodPhase.split('; ').map((podStr, i) => {
                  console.log('podStr:', podStr)
                  return (<div className='ModelDeploymentDetailPage__nodes' key={i}>
                    <div className='ModelDeploymentDetailPage__nodes--row'>
                      <div className='ModelDeploymentDetailPage__nodes--cell id'>ID</div>
                      {/* <div className='ModelDeploymentDetailPage__nodes--cell specs'>Specs</div> */}
                      <div className='ModelDeploymentDetailPage__nodes--cell status'>Status</div>
                    </div>
                    <div className='ModelDeploymentDetailPage__nodes--row'>
                      <div className='ModelDeploymentDetailPage__nodes--cell id'>{getPodId(podStr)}</div>
                      {/* <div className='ModelDeploymentDetailPage__nodes--cell specs'>2398472938742</div> */}
                      <div className='ModelDeploymentDetailPage__nodes--cell status'>{getStatus(podStr)}</div>
                    </div>
                  </div>)
                })}
              {!deployment.PodPhase && <div className='ModelDeploymentDetailPage__nodes'>
                No available pod info yet
              </div>}
            </div>
          })}
        </div>
      }
      {
        (selectedSubTab === 'stats') &&
        <div className='AiServicePage__tab-content'>
          stats
        </div>
      }
      {
        (selectedSubTab === 'logs') &&
        <div className='AiServicePage__tab-content'>
          {(logs && logs.length > 0) ? <div className='AiServicePage__code-container'>
            <SyntaxHighlighter
              lineProps={{ style: { wordBreak: 'break-all', whiteSpace: 'pre-wrap' } }}
              language="javascript"
              style={vscDarkPlus}>
              {logs}
            </SyntaxHighlighter>
          </div> : <div className='EmptyState model-detail'>
            <div className={'EmptyState__title'}>No logs available yet.</div>
          </div>}
        </div>
      }
      {
        (selectedSubTab === 'events') &&
        <div className='AiServicePage__tab-content'>
          {events && events.map((evt, i) => {
            return <div className='AiServicePage__event' key={i}>
              {Object.keys(evt).map((k, i) => {
                return <div className='AiServicePage__event--info' key={i}>
                  <div className={'AiServicePage__event--label'}>{k}:</div>
                  <div className={classNames('AiServicePage__event--value', { 'color-red': k === 'Reason' })}>
                    {k === 'Time' ? formatDate(evt[k]) : evt[k]}
                  </div>
                </div>
              })}
            </div>
          })}
          {(!events || events.length === 0) && <div className='AiServicePage__event--empty-state'>
            No Events
          </div>}
        </div>
      }
    </div>}
    {loading && <div className={'EmptyState'}>
      <Loader size='large' color='grey' />
    </div>}
    {!loading && error && !cluster && <div className={"AiServicePage__error"}>
      {error}
      <Button onClick={fetchData}
        color={"green-outline"}
        title={"Retry"} />
    </div>}
  </div >
  );
}

const NodesTab = ({ deployments }) => {
  const dispatch = useDispatch();
  const { projectId, shard, suffix, id } = useParams();
  return <div className='AiServicePage__tab-content'>
    {deployments && deployments.map((deployment, i) => {
      return <div key={i}>
        deployment #{i}
      </div>
    })}
  </div>
}

const DeploymentsCard = ({ deployments }) => {
  return <>
    <div className='ModelDeploymentDetailPage__details--row section'>
      <div className='ModelDeploymentDetailPage__details--section-title'>
        CLUSTER DETAILS
      </div>
    </div>
    {deployments && deployments.map((deployment, i) => {
      let portKey = _.get(deployment, 'AdditionalPorts.0');
      let mapPort = _.get(deployment, `PortMappings.${portKey}`);
      const sshString = `ssh -i ~/.ssh/id_rsa -p ${mapPort} root@${_.get(deployment, 'NodePublicIP')}`;
      const httpEndpoint = getLinkByDeployment(deployment);
      const httpPort = _.get(deployment, 'ContainerPort')
      return <div className='ModelDeploymentDetailPage__deployment-card' key={i}>
        <div className='ModelDeploymentDetailPage__deployment-card--title'>
          node{i + 1}
        </div>
        <div className='ModelDeploymentDetailPage__deployment-card--row'>
          <div className='ModelDeploymentDetailPage__deployment-card--info'>
            <div className='ModelDeploymentDetailPage__deployment-card--name'>
              SSH
            </div>
            <div className='ModelDeploymentDetailPage__deployment-card--value'>
              {sshString}
            </div>
          </div>
        </div>
        <div className='ModelDeploymentDetailPage__deployment-card--row'>
          <div className='ModelDeploymentDetailPage__deployment-card--info'>
            <div className='ModelDeploymentDetailPage__deployment-card--name'>
              HTTP Port
            </div>
            <div className='ModelDeploymentDetailPage__deployment-card--value'>
              {httpPort ? httpPort : 'N/A'}
            </div>
          </div>
        </div>
        <div className='ModelDeploymentDetailPage__deployment-card--row'>
          <div className='ModelDeploymentDetailPage__deployment-card--info'>
            <div className='ModelDeploymentDetailPage__deployment-card--name'>
              HTTP Endpoint
            </div>
            <div className='ModelDeploymentDetailPage__deployment-card--value'>
              {httpEndpoint ? httpEndpoint : 'N/A'}
              {/* {checkActivePod(deployment) && httpPort > 0 ? getLinkByDeployment(deployment) : ''} */}
            </div>
          </div>
        </div>
        <div className='ModelDeploymentDetailPage__deployment-card--row'>
          <div className='ModelDeploymentDetailPage__deployment-card--info'>
            <div className='ModelDeploymentDetailPage__deployment-card--name'>
              DNS Name
            </div>
            <div className='ModelDeploymentDetailPage__deployment-card--value'>
              {_.get(deployment, 'EnvVars.TEC_NODE_DNS_NAME')}
            </div>
          </div>

        </div>
      </div>
    })}
  </>
}

export default GpuClusterDetailPage;
